// i18n del Modo Carrera (autocontenido: no afecta al resto del sitio). Inglés por defecto;
// español y portugués disponibles vía el selector de idioma (LanguageSelector).
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en';
import es from './locales/es';
import pt from './locales/pt';

export const CAREER_LANG_KEY = 'cs-career-lang';
export const SUPPORTED_LANGS = ['en', 'es', 'pt'];
export const DEFAULT_LANG = 'en';

function readSavedLang() {
    try {
        const saved = localStorage.getItem(CAREER_LANG_KEY);
        return SUPPORTED_LANGS.includes(saved) ? saved : DEFAULT_LANG;
    } catch {
        return DEFAULT_LANG;
    }
}

if (!i18next.isInitialized) {
    i18next.use(initReactI18next).init({
        resources: {
            en: { career: en },
            es: { career: es },
            pt: { career: pt },
        },
        lng: readSavedLang(),
        fallbackLng: DEFAULT_LANG,
        ns: ['career'],
        defaultNS: 'career',
        interpolation: { escapeValue: false }, // React ya escapa
        returnEmptyString: false,
    });
}

export function setCareerLanguage(lang) {
    if (!SUPPORTED_LANGS.includes(lang)) return;
    i18next.changeLanguage(lang);
    try { localStorage.setItem(CAREER_LANG_KEY, lang); } catch { /* localStorage no disponible */ }
}

export function getCareerLanguage() {
    return i18next.language || DEFAULT_LANG;
}

// Nombre de país/nacionalidad localizado al idioma actual, usando la API nativa del navegador
// (Intl.DisplayNames) a partir del código ISO ya mapeado en CODIGO_PAIS. Si no hay traducción
// disponible (navegador viejo, código no reconocido), cae al nombre original (canónico, en
// español) — así nunca se rompe la UI ni se desincroniza de career.nacionalidad / SELECCIONES_BY_PAIS.
const regionNamesCache = {};
export function localizedCountryName(nombreOriginal, isoCode) {
    if (!nombreOriginal) return nombreOriginal;
    if (!isoCode) return nombreOriginal;
    const lang = getCareerLanguage();
    try {
        if (!regionNamesCache[lang]) {
            regionNamesCache[lang] = new Intl.DisplayNames([lang], { type: 'region' });
        }
        const out = regionNamesCache[lang].of(isoCode.toUpperCase());
        return out || nombreOriginal;
    } catch {
        return nombreOriginal;
    }
}

export default i18next;
